export enum Region {
  TOP_LEFT = 0,
  TOP_CENTER = 1,
  TOP_RIGHT = 2,
  MID_LEFT = 3,
  CENTER = 4,
  MID_RIGHT = 5,
  BOTTOM_LEFT = 6,
  BOTTOM_CENTER = 7,
  BOTTOM_RIGHT = 8,
}

export const EnumAlign = {
  None: "None",
  TopLeft: "TopLeft",
  TopCenter: "TopCenter",
  TopRight: "TopRight",
  Center: "Center",
  BottomLeft: "BottomLeft",
  BottomCenter: "BottomCenter",
  BottomRight: "BottomRight",
} as const;

export type EnumAlignType = (typeof EnumAlign)[keyof typeof EnumAlign];

/**
 * EWW-426: how far a TEXT watermark may be scaled, as a multiple of the reference width.
 *
 * Web used to cap this at 1 (100%) in three places, which made it impossible to stretch a
 * rotated text watermark out to the image's diagonal -- the slider was already pinned at max.
 * The mobile app has no such cap: it resizes by gesture, and a template authored there comes
 * back with values well past 1 (a real example carries `"width": 3.6555` and
 * `"scale_ratio": 9.03`, with negative edge ratios marking deliberate overflow). 4x clears the
 * diagonal of any supported canvas ratio with room to spare and stays inside the range mobile
 * already produces, so web can both create and faithfully re-open those templates.
 *
 * Deliberately text-only: an image watermark's 100% already resolves to twice the canvas width
 * (see `scaleToPercentage` in SlidersRow), which covers the diagonal without any change.
 */
export const TEXT_WATERMARK_MAX_SCALE = 4;

export const fontList: readonly string[] = [
  "American Typewriter",
  "Andalé Mono",
  "Arial",
  "Arial Black",
  "Bradley Hand",
  "Brush Script MT",
  "Courier",
  "Courier New",
  "Comic Sans MS",
  "Didot",
  "Georgia",
  "Helvetica",
  "Impact",
  "Lucida Console",
  "Luminari",
  "Monaco",
  "Sans-serif",
  "Verdana",
  "Tahoma",
  "Times New Roman",
  "Trebuchet MS",
  // Mobile App - Local bundled text watermark fonts (src/fonts/TextWatermarkFonts)
  "ArmyWide",
  "BurnstownDam",
  "Endor",
  "EndorAlt",
  "Evanescent",
  "EvanescentP",
  "ItLivesInTheSwampBRK",
  "JennaSue",
  "Lavanderia Sturdy",
  "LavanderiaDelicate",
  "LavanderiaRegular",
  "LittleLordFontleroyNF",
  "Maranallo",
  "MaranalloHigh",
  "MaranalloHighItalic",
  "MaranalloItalic",
  "MetalMacabre",
  "Musicals",
  "Nightbird",
  "OdalisqueNF",
  "PentaGramsMalefissent",
  "RochesterRegular",
  "Rubber",
  "SeasideResortNF",
  "SmartieCAPS",
  "TeamSpiritNF",
  "TheEndFont", // do not add (RF) as () is special char and cause font loading issue
  "Trocadero",
  "WereWolf",
  "YoungBeautiful", // do not add & as & is special char and cause font loading issue
];
